//var Customer=false;
var slevaRegistrace = false;

function pr_resitraciUsetris($pr, priceStandard) {
  let cena = $pr.find("*[data-micro-price]").data("micro-price") || false;

  if (
    !cena ||
    !slevaRegistrace ||
    !Top.Uzivatel.Customer ||
    Top.Uzivatel.Customer.registered
  ) {
    return "";
  }
  let sleva = Math.round(slevaRegistrace.procento * Number(cena));
  sleva = sleva.formatCisla() + " Kč";

  return `<a href="/registrace/" target="_blank">Registrací</a> ušetříš ${
    priceStandard ? "ještě " : ""
  } <strong>${sleva}</strong>`;
}
function pr_odectenaSleva($pr, priceStandard) {
  let cena = $pr.find("*[data-micro-price]").data("micro-price") || false;

  if (
    !cena ||
    !priceStandard ||
    !Top.Uzivatel.Customer ||
    !Top.Uzivatel.Customer.registered
  ) {
    return "";
  }
  priceStandard = priceStandard.prevedNaCislo();
  let sleva = Number(Math.round(priceStandard - cena)).formatCisla() + " Kč";
  return `Odečtená sleva <strong>${sleva}</strong>`;
}

function pr_produkty() {
  if (!$(".products-block").length) return false;
  Lc.f('pr_produkty');

  slevaRegistrace = fce.get(window.ruzne, "sleva.registrace") || false;

  $(".products-block .product .p-desc")
    .not(':data("edit")')
    .html(function(i, t) {
      $(this).data("edit", true);
      var $fce;
      var $pr = $(this).closest(".product");

      if (
        $pr
          .find("a.image")
          .attr("href")
          .includes("/extras/")
      ) {
        $pr.find(".add-to-cart-button").remove();
      }
      //--ikona vide
      $pr.find(".flag-pripravujeme").each(function() {
        $pr.addClass("prVideo");
        $(this).remove();
      });

      $pr.find(".price-final").prependTo($pr.find(".prices"));

      let cil = $pr.find(".ratings-wrapper");

      let priceStandard = false;
      let c = $pr.find(".price-standard").text() || false;
      if (c) {
        priceStandard = c;
        $('<div class="bC">Běžná cena <del>' + c + "</del></div>").prependTo(
          $pr.find(".prices")
        );
      }

      /*
      if (priceStandard) {
        $fce = pr_odectenaSleva($pr, priceStandard);
        if ($fce.length) $(`<div class="oS">${$fce}</div>`).insertBefore(cil);
      }
      */
      $fce = pr_odectenaSleva($pr, priceStandard);
      if ($fce.length) $(`<div class="oS">${$fce}</div>`).insertBefore(cil);

      $fce = pr_resitraciUsetris($pr, priceStandard);
      if ($fce.length) $(`<div class="rU">${$fce}</div>`).insertBefore(cil);

      return t.replace(/\[/g, "<strong>").replace(/\]/g, "</strong>");
    });
} //function  pr_produkty()

export function upravProdukty() {
  pr_produkty();

  document.addEventListener("ShoptetDOMPageMoreProductsLoaded", function() {
    //console.log('----------ShoptetDOMPageMoreProductsLoaded--------------');
    // code to be executed each time you call showPopupWindow
     pr_produkty();
  });

  $( document ).ajaxComplete(function( ) {
     pr_produkty();
  });

  document.addEventListener("ShoptetDOMContentLoaded", function() {
    pr_produkty();
  });
} //export function  upravProdukty()
